import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL or Anon Key is missing. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in your .env file.');
  // For development, you might want to throw an error or handle it gracefully
  // throw new Error('Missing Supabase credentials');
}

export const supabase = createClient(supabaseUrl as string, supabaseAnonKey as string);

console.log('Supabase Client Initialized.', {
  url: supabaseUrl ? '****' + supabaseUrl.substring(supabaseUrl.length - 10) : 'N/A',
  key: supabaseAnonKey ? '****' + supabaseAnonKey.substring(supabaseAnonKey.length - 5) : 'N/A',
});
